import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import type { Props } from 'services/content/components/types/ArticleHeader'
import { generateCommentsFullPathUrl } from 'ui-component-library/utils/helpers'
import {
  getCommentLabelTextString,
  getArticleHeaderStrings,
  getSocialStrings,
} from 'store/strings/selectors'
import useCommentsCount from 'hooks/useCommentsCount'
import ArticleHeader from 'ui-component-library/components/ArticleHeader'

function ArticleHeaderContainer({ topicId, headlineText, ...rest }: Props) {
  const commentsCount = useCommentsCount(topicId)
  const location = useLocation()
  const baseUrl = location.pathname
  const commentLabelText = useSelector(getCommentLabelTextString)
  const { bylineText, categoryLinksLabelText } = useSelector(
    getArticleHeaderStrings,
  )
  const { mailLabelText, navLabelText, twitterLabelText } = useSelector(
    getSocialStrings,
  )
  const commentsUrl = generateCommentsFullPathUrl({
    fullPath: baseUrl,
    topicId,
  })

  return (
    <ArticleHeader
      {...rest}
      bylineText={bylineText}
      categoryLinksLabelText={categoryLinksLabelText}
      baseUrl={baseUrl}
      headlineText={headlineText}
      commentsCount={commentsCount}
      commentLabelText={commentLabelText}
      commentsUrl={commentsUrl}
      mailLabelText={mailLabelText}
      navLabelText={navLabelText}
      twitterLabelText={twitterLabelText}
    />
  )
}

export default ArticleHeaderContainer
